import React from 'react';
import { useTheme } from '@emotion/react';
import { useDispatch } from 'react-redux';
import { redirectToUrl } from '@gumtree/ui-library/src/utils/browser-service';
import { getNonFalsyUrlSearchParams } from '@gumtree/shared/src/util/url-params';
import { Button } from '@gumtree/ui-library';
import type { SrpUseDispatch } from '../../reducers';

import {
    updateButtonCss,
    StyledBlockTitle,
    StyledRangeFreeformFrame,
} from './range-filter-freeform-frame.style';
import { Filter, FiltersDictionary, FilterKey } from '../../types';
import { RangedFreeform } from '../filters/range-freeform';
import { trackGA4FiltersDiffThunk } from '../../reducers/current-filter-states';

export const RangeFilterFreeformFrame = ({
    filterKey,
    currentFilterStates,
    filtersDictionary,
}: {
    filtersDictionary: FiltersDictionary;
    filterKey: FilterKey;
    currentFilterStates: Filter;
}) => {
    const theme = useTheme();
    const dispatch = useDispatch() as SrpUseDispatch;

    const filtersDictionaryEntry = filtersDictionary[filterKey];
    const { minKey, maxKey, label } = filtersDictionaryEntry;

    if (!minKey || !maxKey) {
        return <></>;
    }

    const currentMinValue = currentFilterStates[minKey] as string | undefined;
    const currentMaxValue = currentFilterStates[maxKey] as string | undefined;

    const handleUpdateButtonClick = async () => {
        const url = getNonFalsyUrlSearchParams(currentFilterStates);

        dispatch(trackGA4FiltersDiffThunk());
        redirectToUrl(`/search?${url}`);
    };

    return (
        <StyledRangeFreeformFrame>
            <StyledBlockTitle>{label}</StyledBlockTitle>
            <RangedFreeform
                handleUpdateButtonClick={handleUpdateButtonClick}
                minKey={minKey}
                maxKey={maxKey}
                currentMinValue={currentMinValue}
                currentMaxValue={currentMaxValue}
                filterKey={filterKey}
                isStateful={false}
            />

            <Button
                display="primary"
                label="Update"
                onClick={handleUpdateButtonClick}
                css={updateButtonCss(theme)}
            />
        </StyledRangeFreeformFrame>
    );
};
